import React from 'react';
import styled, { css } from 'styled-components';

const MenuButton = styled.div`
  ${({ theme }) => theme.breakpoints.minDesktop} {
    display: none;
  }

  // change to absolute if navbar not fixed
  position: fixed;
  top: 2.4rem;
  right: 2.4rem;
  z-index: 105;

  height: 2rem;
  width: 2rem;
  padding: 0.5rem 0.25rem;

  &::before,
  &::after {
    content: '';
    display: inline-block;
    position: absolute;
    background: ${({ theme }) => theme.palette.blackLighten5};
    width: 1.5rem;
    height: 0.2rem;
    transition: all 0.2s;
  }

  &::before {
    ${({ isMenuOpen }) =>
      isMenuOpen &&
      css`
        transform: rotate(-135deg);
        top: 0.8rem;
        background: ${({ theme }) => theme.palette.whiteBase};
      `}
  }
  &::after {
    bottom: 0.5rem;

    ${({ isMenuOpen }) =>
      isMenuOpen &&
      css`
        transform: rotate(135deg);
        bottom: 1rem;
        background: ${({ theme }) => theme.palette.whiteBase};
      `}
  }
`;

const MobileMenuButton = ({ toggleMobileMenu, isMenuOpen }) => (
  <MenuButton onClick={toggleMobileMenu} isMenuOpen={isMenuOpen} />
);

export default MobileMenuButton;
